module.exports = __webpack_public_path__ + "static/mft-03d4b6b6ec802339afa6c41492dfa2ab.jpg";